<template>
  <div class="page">
    <div class="aside">
      <div class="top" style="margin-right:20px;">
        <span style="padding-right:10px;">发送状态</span>
        <el-select v-model="value" placeholder="请选择" @change="change">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" placeholder="全部"></el-option>
        </el-select>
      </div>
      <div class="top">
        <span>选择时间：</span>
        <el-date-picker @change="timechange" v-model="value2" value-format="timestamp" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"></el-date-picker>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%;" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{background:'#f5f7fa',color:'#606266', 'text-align': 'center'}">
      <el-table-column label="红包类型" width="200">
        <template slot-scope="scope">
          <span v-show="tableData[scope.$index].link == 1">发送的红包</span>
          <span v-show="tableData[scope.$index].link == 2">收到的红包</span>
        </template>
      </el-table-column>
      <el-table-column label="红包样式" width="200">
        <template slot-scope="scope">
          <span v-show="tableData[scope.$index].type == 1">普通红包</span>
          <span v-show="tableData[scope.$index].type == 2">贺卡红包</span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="红包金额" width="200"></el-table-column>
      <el-table-column prop="created_at" label="时间" width="200"></el-table-column>
      <el-table-column label="状态" width="200">
        <template slot-scope="scope">
          <span v-show="tableData[scope.$index].status == 1 && tableData[scope.$index].link == 2">未接收</span>
          <span v-show="tableData[scope.$index].status == 2 && tableData[scope.$index].link == 2">已接收</span>
          <span v-show="tableData[scope.$index].status == 3 && tableData[scope.$index].link == 2">已退回</span>
          <span v-show="tableData[scope.$index].status == 1 && tableData[scope.$index].link == 1">发送中</span>
          <span v-show="tableData[scope.$index].status == 2 && tableData[scope.$index].link == 1">已退回</span>
          <span v-show="tableData[scope.$index].status == 3 && tableData[scope.$index].link == 1">已完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <span style="color:#96a9e9;" @click="detail(scope.$index)">详情</span>
          <span style="color:#96a9e9;padding-left:5px;" v-show="tableData[scope.$index].link == 2" @click="receive(scope.$index)">领取</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pagesize" layout="total,  prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    <el-dialog title="红包详情" :visible.sync="centerDialogVisible" width="50%" center>
      <div style="margin-left:20px;">
        <div v-show="detaildata.link == 1">
          <span style="padding-right:10px;">红包总金额</span>
          <span style="color:red;">
            ￥
            <span style="font-size:15px;">{{detaildata.total_amount}}</span>
          </span>
        </div>
        <div v-show="detaildata.link == 2">
          <span style="padding-right:10px;">红包金额</span>
          <span style="color:red;">
            ￥
            <span style="font-size:15px;">{{detaildata.money}}</span>
          </span>
        </div>
        <div style="padding-top:10px;" v-show="detaildata.link == 1">
          <span style="padding-right:10px;">单个金额</span>
          <span style="color:red;">
            ￥
            <span style="font-size:15px;">{{detaildata.money}}</span>
          </span>
        </div>
        <div style="margin:10px 0;">
          <span style="padding-right:10px;">红包状态</span>
          <span v-show="detaildata.link == 1">发送的红包</span>
          <span v-show="detaildata.link == 2">收到的红包</span>
        </div>
        <div>
          <span style="padding-right:10px;">红包样式</span>
          <span v-show="detaildata.type == 1">普通红包</span>
          <span v-show="detaildata.type == 2">贺卡红包</span>
        </div>
        <div style="padding:10px 0;">
          <span style="padding-right:10px;">发送时间</span>
          <span>{{detaildata.created_at}}</span>
        </div>
        <div>
          <span style="padding-right:10px;">收款项目</span>
          <span>{{detaildata.name}}</span>
        </div>
        <div style="padding:10px 0;">
          <span style="padding-right:10px;">红包说明</span>
          <span>{{detaildata.content}}</span>
        </div>
        <div v-show="detaildata.link == 1">
          <span style="padding-right:10px;">接收人员</span>
          <span>共{{detaildata.total}}人</span>
        </div>
        <div v-show="detaildata.link == 2">
          <span style="padding-right:10px;">付款人员</span>
          <span>{{detaildata.nickname}}</span>
        </div>
        <el-table v-show="detaildata.link == 1" style="width:100%" max-height="150" :data="detaildata.logs" :border="false" :cell-style="{ 'text-align': 'center' }" :header-cell-style="{background:'#f5f7fa',color:'#606266', 'text-align': 'center'}">
          <el-table-column prop="user_name" label="收款人" width="100"></el-table-column>
          <el-table-column prop="money" label="金额" width="100"></el-table-column>
          <el-table-column prop="content" label="备注" width="100"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span style="color:blue;">主页</span>
              <span style="color:#96a9e9;padding-left:5px;" @click="receives(scope.$index)">领取</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { redpackList, redpackInfo, redpackdraw } from "@/api/login/login";
export default {
  data () {
    return {
      value2: "",
      timestart: "",
      timeend: "",
      i: 0,
      pagesize: 5,
      currentpage: 1,
      tableData: [],
      total: -1,
      value: "",
      options: [
        {
          value: "0",
          label: "全部"
        },
        {
          value: "1",
          label: "未接收"
        },
        {
          value: "2",
          label: "已接收"
        },
        {
          value: "3",
          label: "已退回"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      centerDialogVisible: false,
      detaildata: {},
      redindex: 0
    };
  },
  created () {
    this.getlist();
  },
  methods: {
    //红包领取
    receives (index) {
      let data = {
        data: {
          redpack_id: this.detaildata.logs[index].redpack_id,
          user_app_id: this.detaildata.logs[index].user_app_id
        }
      };
      redpackdraw(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getlist();
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //红包领取
    receive (index) {
      let data = {
        data: {
          redpack_id: this.tableData[index].id,
          user_app_id: this.tableData[index].user_app_id
        }
      };
      redpackdraw(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getlist();
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //充值记录分页
    handleSizeChange (val) {
      this.pagesize = val;
      this.getlist();
    },
    handleCurrentChange (val) {
      this.currentpage = val;
      if (this.i == 0) {
        this.getlist();
      } else {
        let data = {
          limit: this.pagesize,
          page: this.currentpage,
          status: this.i
        };
        redpackList(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
    //选择时间
    timechange (e) {
      this.timestart = e[0] / 1000;
      this.timeend = e[1] / 1000;
      if (this.i == 0) {
        let data = {
          start_time: this.timestart,
          end_time: this.timeend,
          limit: this.pagesize,
          page: this.currentpage
        };
        redpackList(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      } else {
        let data = {
          status: this.i,
          start_time: this.timestart,
          end_time: this.timeend,
          limit: this.pagesize,
          page: this.currentpage
        };
        redpackList(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    },
    //红包记录
    getlist () {
      let data = {
        limit: this.pagesize,
        page: this.currentpage
      };
      redpackList(data).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    //详情
    detail (index) {
      this.redindex = index;
      this.centerDialogVisible = true;
      let data = {
        id: this.tableData[index].id
      };
      redpackInfo(data).then(res => {
        this.detaildata = res.data;
      });
    },
    //选择发送状态
    change (e) {
      this.i = e;
      if (e == 0) {
        this.getlist();
      } else {
        let data = {
          limit: this.pagesize,
          page: this.currentpage,
          status: e
        };
        redpackList(data).then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
      }
    }
  },
  components: {}
};
</script>

<style lang='scss' scoped>
.page {
  .detailsty {
    .detailsty_child {
      display: flex;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px;
    border: 1px #ccc solid;
    width: 200px;
    height: 30px;
    border-radius: 7px;
  }
  height: auto !important;
  .aside {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .block {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    padding-bottom: 10px;
  }
}
</style>
